"use client";

import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function LocalVerificationQr({ image }: { image?: string | null }) {
  const [demo, setDemo] = useState("");
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    // Text-only payload: scanning cannot create a session or write verification results.
    QRCode.toDataURL("这是入驻认证演示二维码，不会发起实名认证或改变入驻进度。", { width: 320, margin: 3, errorCorrectionLevel: "M" })
      .then(value => { if (active) setDemo(value); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  const source = image || demo;
  return <div className="rg-face-qr-card">
    {source ? <img src={source} width={280} height={280} alt={image ? "手机刷脸认证入口二维码" : "演示二维码"} /> /* eslint-disable-line @next/next/no-img-element */ : <span role="status">{failed ? "二维码生成失败，请刷新重试" : "正在加载二维码…"}</span>}
  </div>;
}
